export const FALLBACK_TO_BOOTDATA_WARNING = `PluginMeta: plugin meta yielded an empty result so Grafana is falling back to bootdata`;
export const FALLBACK_TO_BOOTDATA_ERROR_WARNING = `PluginMeta: plugin meta failed to load so Grafana is falling back to bootdata`;
